/* eslint-disable */

import {
  confirmed,
  length,
  email,
  numeric,
  digits,
  alpha_num
} from 'vee-validate/dist/rules'
import { extend } from 'vee-validate'

extend('required', {
  validate(value) {
    return {
      required: true,
      valid: ['', null, undefined].indexOf(value) === -1
    }
  },
  message: 'Este campo es requerido',
  computesRequired: true
})

extend('email', {
  ...email,
  message: 'Ingrese un correo válido'
})

extend('confirmed', {
  ...confirmed,
  message: 'Los campos deben coincidir'
})

extend('length', {
  ...length,
  message: 'Longitud incorrecta'
})

extend('numeric', {
  ...numeric,
  message: 'Solo se aceptan números'
})

extend('digits', {
  ...digits,
  message: 'El número de teléfono debe tener 10 dígitos'
})

extend('min', {
  validate(value, params: Record<string, any>) {
    let minParam = params[0] as number

    return {
      required: true,
      valid: value.toString().length >= minParam
    }
  },
  message: (_, params) =>
    'El campo no acepta más de ' + params[0] + ' caracteres'
})

extend('max', {
  validate(value, params: Record<string, any>) {
    let maxParam = params[0]

    return {
      required: true,
      valid: value.toString().length <= maxParam
    }
  },
  message: (_, params) =>
    'El campo no acepta más de ' + params[0] + ' caracteres'
})

extend('alpha_num', {
  ...alpha_num,
  message: 'Solo se aceptan caracteres alfanumericos'
})

extend('half_hour', {
  validate(value: string) {
    if (!value) return false
    const [_, minutes] = value.split(':')
    return minutes === '00' || minutes === '30'
  },
  message: 'Solo se puede seleccionar el minuto 00 o 30'
})
/* eslint-enable */
